var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usePlugFilespaceClient, } from '@lucidlink/workspacemanagement';
import { buildGlobalUnsetContext, emitGlobalUnsetTelemetry } from '#telemetry';
import { FilespaceSettingsKeyFactory } from '../query-key-factories';
export const useUnsetGlobalSettings = ({ filespaceId, setting, workspaceId }, { onError, onSuccess }) => {
    _react_refresh_temp_1();
    const queryClient = useQueryClient();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const mutation = useMutation({
        mutationKey: FilespaceSettingsKeyFactory.unsetGlobal(filespaceId, setting),
        onMutate: async (settings) => plugFilespaceClient({
            action: (fsClient) => buildGlobalUnsetContext(settings, fsClient),
            filespaceId,
            workspaceId,
        }),
        mutationFn: async (settings) => plugFilespaceClient({
            action: (fsClient) => fsClient.globalSettingManager().unset(settings),
            filespaceId,
            workspaceId,
        }),
        onSuccess: async (_data, variables, context) => {
            try {
                if (context) {
                    void plugFilespaceClient({
                        action: (fsClient) => emitGlobalUnsetTelemetry(variables, context, fsClient),
                        filespaceId,
                        workspaceId,
                    });
                }
                await queryClient.refetchQueries({
                    exact: true,
                    queryKey: FilespaceSettingsKeyFactory.global(filespaceId),
                });
            }
            finally {
                if (onSuccess && typeof onSuccess === 'function') {
                    onSuccess();
                }
            }
        },
        onError: () => {
            if (onError && typeof onError === 'function') {
                onError();
            }
        },
        networkMode: 'always',
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(useUnsetGlobalSettings, "o0s1hYhUCjAbRTTY8BWLnVP5U/c=", false, () => [useQueryClient, usePlugFilespaceClient, useMutation]);
